import { React } from "react";
import { Box, CardMedia, makeStyles, Typography } from "@material-ui/core";
import { ToggleButton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  button: {
    width: 138,
    height: 135,
    marginTop: 20,
    marginRight: 20,
    // color: "grey",

    borderColor: "transparent",
    backgroundColor: theme.white,
    boxShadow: "inset 1px 4px 4px  rgba(0, 0, 0, 0.25)",
    borderRadius: "20px",
  },

  selected: {
    backgroundColor: theme.orange + "!important",
  },

  box: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  media: {
    objectFit: "contain",
    objectPosition: "center",
  },
  icons: {
    width: 58,
    height: 58,
  },
  nameOfButton: {
    textAlign: "center",
    fontSize: 18,
  },
  normalText: { color: theme.darkGray },
  selectedText: { color: theme.white },
}));

function GridMenu({
  nameOfButton,
  icon,
  key,
  value,
  onClick,
  selected,
  disabled,
}) {
  const classes = useStyles();

  return (
    <ToggleButton
      value={value}
      key={key}
      onClick={onClick}
      selected={selected}
      classes={{ root: classes.button, selected: classes.selected }}
      disabled={disabled}
    >
      <Box className={classes.box} style={{ pointerEvents: "none" }}>
        {icon ? (
          <CardMedia
            image={icon}
            alt={value}
            classes={{ root: classes.icons, media: classes.media }}
            component="img"
            style={{ pointerEvents: "none" }}
          />
        ) : null}

        <Typography
          className={[
            classes.nameOfButton,
            selected ? classes.selectedText : classes.normalText,
          ]}
        >
          {nameOfButton}
        </Typography>
      </Box>
    </ToggleButton>
  );
}

export default GridMenu;
